import {ValidationErrorCode} from '../../types/validation/ValidationErrorCode';
import {validationErrorMessages} from './validationErrorMessages';

export const getValidationErrorMessage = (code?: ValidationErrorCode) => {
  if (!code) {
    return '';
  }

  return validationErrorMessages[code];
}